import { Container } from "@mantine/core";
import classes from "../styles/FormsSection.module.css";

const FEATURES = [
  {
    icon: "📋",
    title: "בניית טפסים מותאמים אישית",
    desc: "צרו כל סוג של טופס: שאלוני בריאות, הצהרות, סקרי שביעות רצון בכמה לחיצות בלבד",
  },
  {
    icon: "✍️",
    title: "חתימה דיגיטלית מובנית",
    desc: "הלקוח חותם ישירות במערכת על מסמכים, הצהרות בריאות ואחריות הכל מאובטח ומשפטי",
  },
  {
    icon: "🎛️",
    title: "שדות חובה וסוגי שדות",
    desc: "שאלות אמריקאיות, בחירה מרובה, טקסט חופשי, שדות חובה/אופציונאלי שליטה מלאה",
  },
  {
    icon: "⚡",
    title: "הדבקה מטופס קיים",
    desc: "מעתיקים את הטקסט מהטופס שכבר יש לך (Word, PDF או Excel), מדביקים, והמערכת בונה ממנו את השאלות לבד",
  },
];

/* ── Decorative mock form card ── */
function MockFormCard() {
  return (
    <div className={classes.mockCard}>
      {/* Window chrome */}
      <div className={classes.mockCardHeader}>
        <div className={classes.mockCardDots}>
          <div className={classes.mockCardDot} style={{ background: "#ff5f57" }} />
          <div className={classes.mockCardDot} style={{ background: "#febc2e" }} />
          <div className={classes.mockCardDot} style={{ background: "#28c840" }} />
        </div>
        <span className={classes.mockCardTitle}>📋 הצהרת בריאות לקוחה חדשה</span>
      </div>

      {/* Upload from file */}
      <div className={classes.mockUploadBadge}>
        <span className={classes.mockUploadIcon}>✨</span>
        <div className={classes.mockUploadTextWrap}>
          <span className={classes.mockUploadTitle}>הדבקת טקסט מטופס קיים</span>
          <span className={classes.mockUploadSub}>הצהרת בריאות הודבקה, הטופס נבנה אוטומטית</span>
        </div>
      </div>

      {/* Name field */}
      <div className={classes.mockFormRow}>
        <div className={classes.mockLabel}>
          שם מלא <span className={classes.mockRequired}>* חובה</span>
        </div>
        <div className={`${classes.mockInput} ${classes.mockInputFilled}`} />
      </div>

      {/* Radio group */}
      <div className={classes.mockFormRow}>
        <div className={classes.mockLabel}>האם יש לך רגישות לחומרים? <span className={classes.mockRequired}>* חובה</span></div>
        <div className={classes.mockRadioGroup}>
          <div className={`${classes.mockRadioItem} ${classes.selected}`}>
            <div className={`${classes.mockRadioDot} ${classes.filled}`} />
            <span className={classes.mockRadioText}>לא, אין לי רגישויות</span>
          </div>
          <div className={classes.mockRadioItem}>
            <div className={classes.mockRadioDot} />
            <span className={classes.mockRadioText}>כן, יש לי רגישויות</span>
          </div>
          <div className={classes.mockRadioItem}>
            <div className={classes.mockRadioDot} />
            <span className={classes.mockRadioText}>לא בטוח/ה</span>
          </div>
        </div>
      </div>

      {/* Additional field */}
      <div className={classes.mockFormRow}>
        <div className={classes.mockLabel}>הערות נוספות <span style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.68rem" }}>(אופציונאלי)</span></div>
        <div className={classes.mockInput} style={{ height: 48 }} />
      </div>

      {/* Signature row */}
      <div className={classes.mockSignRow}>
        <span style={{ fontSize: "1.1rem" }}>✍️</span>
        <span className={classes.mockSignText}>לחץ לחתימה דיגיטלית</span>
      </div>

      {/* Submit */}
      <div className={classes.mockSubmitBtn}>
        <span className={classes.mockSubmitText}>אישור ושליחת הטופס ✓</span>
      </div>

      {/* Floating tags */}
      <div className={`${classes.floatingTag} ${classes.floatingTag1}`}>
        🔒 חתימה מאובטחת
      </div>
      <div className={`${classes.floatingTag} ${classes.floatingTag2}`}>
        ⚡ נוצר אוטומטית
      </div>
    </div>
  );
}

/* ── Main exported component ── */
export function FormsSection() {
  return (
    <div className={classes.sectionWrapper}>
      <Container size="xl" style={{ position: "relative", zIndex: 2 }}>
        <div className={classes.twoCol}>

          {/* Left — text content */}
          <div className={classes.textCol}>
            <div className={classes.headerBadge}>
              📋 &nbsp;פיצ'ר בלעדי טפסים דיגיטליים
            </div>

            <h2 className={classes.sectionTitle}>
              בניית טפסים ושאלונים<br />
              <span>חכמה, מהירה ומאובטחת</span>
            </h2>

            <p className={classes.sectionSubtitle}>
              במקום לחפש ניירות ולשלוח PDF הלקוחות ממלאים ישירות במערכת, חותמים דיגיטלית, והכל שמור אצלכם אוטומטית.
            </p>

            <div className={classes.featureList}>
              {FEATURES.map((f, i) => (
                <div key={i} className={classes.featureItem}>
                  <span className={classes.featureIcon}>{f.icon}</span>
                  <div className={classes.featureTextWrap}>
                    <span className={classes.featureItemTitle}>{f.title}</span>
                    <span className={classes.featureItemDesc}>{f.desc}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Magic badge */}
            <div className={classes.magicBadge}>
              <span className={classes.magicBadgeIcon}>🪄</span>
              <span className={classes.magicBadgeText}>
                <strong>פתרון קסם: הדבקה מטופס קיים</strong>
                יש לכם כבר הצהרת בריאות ב-Word, PDF או Excel?
                מעתיקים את הטקסט ומדביקים, והמערכת בונה את הטופס המלא אוטומטית, בלי לבנות כל שאלה ידנית ✨
              </span>
            </div>

            <a
              href="https://app.quicktor.co.il/MainPageToConnect/CreateBusinessAccount"
              className={classes.ctaBtn}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>נסו בחינם 14 יום</span>
              <span className={classes.ctaBtnArrow}>←</span>
            </a>
          </div>

          {/* Right — visual mock */}
          <div className={classes.visualCol}>
            <MockFormCard />
          </div>

        </div>
      </Container>
    </div>
  );
}
